import { render, staticRenderFns } from "./PortalLayout.vue?vue&type=template&id=05022b72&"
import script from "./PortalLayout.vue?vue&type=script&lang=js&"
export * from "./PortalLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports